import { useState } from 'react';

import loadable from '@loadable/component';
import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';
import { Grid, Heading, useTheme, Button } from '@simplywallst/ui-core';
import If from '@components/If';
import { CompanyNoteModalProvider } from '@/components/Note/components/CompanyNoteModalContext';

import SideMenu from '../SideMenu';
import { Overview } from '@/components/MonitoringPanel';

import { Narrative } from '@/pages/PublicNarrativeAuthoring/hooks/useNarrativeById';
import { CompanyInfoContainer, UpdatesContainer } from './styled';

const Notes = loadable(() => import('./Notes'), { ssr: false });
const CompanyFeed = loadable(() => import('@/components/CompanyFeed'), {
  resolveComponent: (c) => c.CompanyFeed,
  ssr: false,
});

interface Props {
  company: NonNullable<Narrative['company']>;
}

type SideMenuState = 'notes' | 'updates' | 'closed';

export const CompanyInfo = ({ company }: Props) => {
  const theme = useTheme();
  const [sideMenuState, setSideMenuState] = useState<SideMenuState>('closed');

  return (
    <CompanyNoteModalProvider>
      <CompanyInfoContainer templateRows="max-content">
        <Overview selectTab={setSideMenuState} company={company} />
        <SideMenu
          show={sideMenuState !== 'closed'}
          close={() => setSideMenuState('closed')}
        >
          <If match={sideMenuState === 'notes'}>
            {() => (
              <Notes
                companyId={company.id}
                uniqueSymbol={company.uniqueSymbol}
                closeSidebar={() => setSideMenuState('closed')}
              />
            )}
          </If>
          <If match={sideMenuState === 'updates'}>
            {() => (
              <UpdatesContainer
                gap={`${theme.x2spacePx}px`}
                justifyContent="center"
              >
                <Grid templateColumns="1fr auto ">
                  <Heading as="h3" textAlign="center">
                    Recent News & Updates
                  </Heading>
                  <Button onClick={() => setSideMenuState('closed')}>
                    <CrossSolid
                      height={20}
                      width={20}
                      fill="white"
                      opacity={0.5}
                    />
                  </Button>
                </Grid>

                <CompanyFeed lookup={company.canonicalURL} />
              </UpdatesContainer>
            )}
          </If>
        </SideMenu>
      </CompanyInfoContainer>
    </CompanyNoteModalProvider>
  );
};
